import type { KeyedMutator } from 'swr';
import type { EntityContextType } from 'components/scenes';

/**
 * Entity context for catalogue actions rendered outside an entity scene
 * (drawers). `mutate` keeps post-action refreshes working (e.g. CONVERT);
 * `setItem`/`setSpinning` have no drawer equivalent and stay inert.
 */
export function drawerEntityContext<I>(item: I, endpoint: string, mutate: () => unknown): EntityContextType<I> {
  return {
    endpoint,
    item,
    setItem: () => undefined,
    // EntityContextType expects a KeyedMutator of the item; drawers only ever
    // invoke it with no arguments to reconcile, so any promise-returning
    // refresh callback is a valid implementation.
    mutate: mutate as KeyedMutator<I>,
    setSpinning: () => undefined,
  };
}
